module.exports = __webpack_public_path__ + "img/天气微博@2x.f6f1f7b6.png";